const createCronTemplate = async ({ params, api }) => {
  return await api('cronTemplate', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createCronTemplate;